export const FORBIDDEN_ROW = '[FORBIDDEN_ROW]'
export const LOGGED_OUT = '[LOGGED_OUT]'

export const FORBIDDEN_ROW_CONFIG = [FORBIDDEN_ROW, 1]
